import { Node, Text } from 'slate'

function stringify (node) {
  if (node.type === 'checkbox') {
    return `${node.isChecked ? '✅' : '❎'} ${Node.string(node)}`
  }

  if (node.type === 'checkbox-list-item') {
    return `${node.isChecked ? '✅' : '❎'} ${Node.string(node)}`
  }

  if (Text.isText(node)) {
    return Node.string(node)
  }

  return node.children.map(stringify).join('')
}

export function serializeContent (content) {
  return content
    .map(node => stringify(node))
    .join(' ')
    .replace(/\s+/g, ' ')
}
